// ESM re-export of the CJS-tested order-doc render helpers, so the JSX can
// import them while Jest unit-tests the .cjs sibling directly (no ESM
// transform under Jest). esbuild bundles the CJS module fine.
export {
  modeBadge, confidenceChip, warningLines, railContextForRow, scheduleLine,
  blankDxCount, reviewSendLabel, blankDxWarning, orderDxPrintedLine, rowsKeyFor,
} from './order-doc-helpers.cjs';
